import { Component, forwardRef, Host, Input, Optional, SkipSelf, ViewEncapsulation } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MatDatepicker } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { DatepickerComponent } from '../datepicker';
import {Helper} from '../../classes/helpers';

@Component({
  selector: 'app-year-datepicker',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YearDatepickerComponent),
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'YYYY',
        },
        display: {
          dateInput: 'YYYY',
          monthYearLabel: 'YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'YYYY',
        },
      }
    },
  ],
  encapsulation: ViewEncapsulation.None
})

export class YearDatepickerComponent extends DatepickerComponent {
  @Input() public disabled: boolean;
  @Input() public outlined: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer
  ) {
    super(controlContainer);

    this.disabled = false;
    this.outlined = false;
  }

  yearHandler(momentValue: any, datepicker: MatDatepicker<any>): void {
    const date = momentValue.year().toString();

    if (this.onChange) {
      this.onChange(date);
    }

    super.writeValue(date);
    datepicker.close();
  }
}
